<template>
  <tr>
    <td class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.checkBox">
      <label class="checkbox mb-0">
        <input
          :id="item.id"
          v-model="item.selected"
          type="checkbox"
          :disabled="warehouse.isOnHold || item.isAllowedToShip === false"
          @change="$emit('update-allocated-items')"
        />
        <span class="control-indicator"></span>
      </label>
    </td>
    <td class="b2b-grid__cell lg:table-cell whitespace-nowrap" qaid="warehouse.grid.row.notes">
      <div class="flex">
        <grid-icon
          v-if="item.isSplitWarehouse"
          :data="{
            value: 'call_split',
          }"
        ></grid-icon>
        <grid-note
          v-show="item.lineComment || notesEditable"
          :row-id="item.id"
          :data="{
            value: 'insert_drive_file',
            content: item.lineComment,
            editable: notesEditable,
            cssClass: 'ml-1',
          }"
          :base-properties="baseProperties"
        >
        </grid-note>
      </div>
    </td>
    <td class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.itemName">
      <div class="b2b-grid__label">{{ getHeader('item') }}</div>
      <div class="b2b-grid__content">
        {{ item.itemName }}
      </div>
    </td>
    <td class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.orderNumber">
      <div class="b2b-grid__label">{{ getHeader('orderNumber') }}</div>
      <div class="b2b-grid__content">
        <a :href="orderLinkUrl" class="underline hover:no-underline">
          {{ item.orderNumber }}
        </a>
      </div>
    </td>
    <td class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.poNumber">
      <div class="b2b-grid__label">{{ getHeader('poNumber') }}</div>
      <div class="b2b-grid__content">
        {{ item.poNumber }}
      </div>
    </td>
    <td class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.itemSku">
      <div class="b2b-grid__label">{{ getHeader('sku') }}</div>
      <div class="b2b-grid__content">
        <div class="flex items-center">
          <a
            :href="`${encodedContextPath}/my-account/orders?partNumber=${item.sku}`"
            class="leading-none mr-1"
            qaid="warehouse.grid.row.orderHistory"
          >
            <i class="material-icons">history</i>
          </a>
          <a :href="pdpUrl" class="underline hover:no-underline">
            {{ item.sku }}
          </a>
        </div>
      </div>
    </td>
    <td v-if="!consumerFriendlyMode" class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.unitPrice">
      <div class="b2b-grid__label">{{ getHeader('price') }}</div>
      <div class="b2b-grid__content">
        {{ item.unitPrice }}
      </div>
    </td>
    <td class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.quantityOrder">
      <div class="b2b-grid__label">{{ getHeader('qty') }}</div>
      <div class="b2b-grid__content">
        {{ item.quantityOrdered }}
      </div>
    </td>
    <td class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.quantityAllocatedOrShipped">
      <div class="b2b-grid__label">{{ getHeader('allocated') }}</div>
      <div class="b2b-grid__content">
        {{ item.quantityAllocatedOrShipped }}
      </div>
    </td>
    <td class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.cancelDate">
      <div class="b2b-grid__label">{{ getHeader('cancellationDate') }}</div>
      <div v-if="item.cancelDate" class="b2b-grid__content items-center">
        <i v-if="item.showCancelFlag" class="md-18 text-warning mr-25">warning</i>
        {{ item.cancelDate }}
      </div>
    </td>
    <td v-if="!consumerFriendlyMode" class="b2b-grid__cell lg:table-cell" qaid="warehouse.grid.row.subTotal">
      <div class="b2b-grid__label">{{ getHeader('subtotal') }}</div>
      <div class="b2b-grid__content">
        {{ item.lineSubtotal }}
      </div>
    </td>
  </tr>
</template>

<script>
import find from 'lodash/find';
import {mapState, mapGetters} from 'vuex';
import GridIcon from '@/components/grid/GridIcon';
import GridNote from '@/components/grid/GridNote';

export default {
  components: {GridIcon, GridNote},

  props: {
    item: {
      type: Object,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => [],
    },
    warehouse: {
      type: Object,
      default: () => {},
    },
    baseProperties: {
      type: Array,
      default: () => [],
      required: false,
    },
  },

  data() {
    return {
      notesEditable: false,
    };
  },

  computed: {
    orderLinkUrl() {
      // make sure we have ordertype and ordercompany available
      const {orderNumber, orderType, orderCompany} = this.item;

      return `${this.encodedContextPath}/my-account/order/${orderNumber}?company=${orderCompany}&ordertype=${orderType}`;
      // return "a";
    },

    pdpUrl() {
      return `${this.encodedContextPath}/p/${this.item.sku}/`;
    },

    ...mapState('backend', ['encodedContextPath']),
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  mounted() {
    if (this.warehouse.isOnHold || this.item.isAllowedToShip === false) {
      return this.$set(this.item, 'selected', false);
    }
    if (this.item.selected === undefined && this.item.isAllowedToShip === true) {
      return this.$set(this.item, 'selected', true);
    }
  },

  methods: {
    getHeader(headerName) {
      let header = find(this.headers, (header) => header.name === headerName);
      return header ? header.label : '';
    },
  },
};
</script>
